import React from "react";
import PrintOrderScreen from "./PrintOrderScreen";

function SelectedPrintOrderScreen({
  selectedPhotos = [],
  onBack,
  quantities,
  setQuantities,
  photoOverlays,
  setPhotoOverlays,
  croppedImages,
  setCroppedImages,
}) {
  return (
    <PrintOrderScreen
      selectedPhotos={selectedPhotos}
      startIndex={0}
      onBack={onBack}
      quantities={quantities}
      setQuantities={setQuantities}
      photoOverlays={photoOverlays}
      setPhotoOverlays={setPhotoOverlays}
      croppedImages={croppedImages}
      setCroppedImages={setCroppedImages}
    />
  );
}

export default SelectedPrintOrderScreen;